<template>
  <div class="accordion">
    <template v-if="items">
      <fn-accordion-item
        v-for="(item, index) in items"
        :id="item.id ? item.id : 'accordion-item-' + index"
        :key="index"
        :tracking-id="item.tracking_id"
        :headline="item.headline"
        :secondary="secondary"
        :fixed-width="fixedWidth"
        :background-color="item.background_color"
        :left-padding="item.left_padding"
        :advice="advice"
        :active="checkItemIsActive(item)"
        :disable-scroll-to-item="disableScroll"
        tabindex="-1"
        @toggle="() => toggleItem(item)"
      >
        <div
          v-if="item.content && !item.components"
          v-html="replacedTextWithDynamicFields(item.content)"
        />
        <fn-cms-component-loader
          v-for="component in item.components"
          v-else
          :key="component.acf_fc_layout"
          :type="component.acf_fc_layout"
          :data="component"
        />
      </fn-accordion-item>
    </template>

    <slot />
  </div>
</template>

<script>
import DynamicFieldsReplacer from '@/mixins/DynamicFieldsReplacer';

export default defineComponent({
  mixins: [DynamicFieldsReplacer],
  props: {
    items: {
      type: Array,
      default: null,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    fixedWidth: {
      type: Boolean,
    },
    addLdJson: {
      type: Boolean,
      default: false,
    },
    advice: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    if (props.addLdJson && props.items?.length) {
      const ldJson = useFAQPage(props.items);

      useHead({
        script: [
          {
            key: 'ldjson-faq',
            type: 'application/ld+json',
            children: ldJson,
          },
        ],
      });
    }
  },
  data: () => ({
    activeItems: [],
    disableScroll: false,
  }),
  mounted() {
    if (!this.items) return;

    this.items.forEach((item) => {
      if (item.toggled_open) {
        this.disableScroll = true;
        this.activeItems.push(item);
      }
    });
  },
  methods: {
    toggleItem(item) {
      const isActive = this.checkItemIsActive(item);
      if (isActive) {
        this.activeItems.splice(this.activeItems.indexOf(item), 1);
      } else {
        this.activeItems.push(item);
      }
    },
    checkItemIsActive(item) {
      return this.activeItems.includes(item);
    },
  },
});
</script>
